import { createGlobalStyle } from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  calculateMobileResponsiveSize
} from 'styles/media-queries'

const GlobalStyle = createGlobalStyle`
  :root {
  }
  html, body{
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    font-size: ${calculateResponsiveSize(14)};
    color: #1B191A;
    line-height: 1.25;
    background: #F7F3EB;
    min-width: 320px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    ${mediaMax('mobile')} {
      font-size: ${calculateMobileResponsiveSize(14)};
    }
  }
  body{
    overflow-y: scroll;
  }
  body.hidden {
    height: 100svh !important;
  }
  body.hidden .wrapper {
    height: 100svh;
    overflow: hidden;
  }
  html, body, A, input, select, textarea, button{
    font-family: 'Optima BQ', Arial, Tahoma, Geneva, Kalimati, sans-serif;
  }
  A{
    text-decoration: none;
    color: #1B191A;
    outline: none;
  }
  A:hover{
    text-decoration: underline;
  }
  input, select, textarea {
    vertical-align: top;
    outline: none;
  }
  /* ----- Safari profile icon ----- */
  input::-webkit-contacts-auto-fill-button {
    visibility: hidden;
    display: none !important;
    pointer-events: none;
    position: absolute;
    right: 0;
  }
  textarea {
    resize: vertical;
  }
  *{ -webkit-tap-highlight-color: transparent; box-sizing: border-box; }
  img, object, iframe, svg{ border: 0; vertical-align: top; }
  button { font-weight: 400; }
  /* .content {
    will-change: transform; 
  } */
  /* ----- react-select ----- */
  @keyframes selectSlideInOut {
    0% {
      transform: translateY(-1px);
    }
    100% {
      transform: translateY(0);
    }
  }

  /* ----- For br ----- */
  .for-mobile {
    display: none;
  }
  ${mediaMax('mobile')} {
    .for-desktop {
      display: none;
    }
    .for-mobile {
      display: inline;
    }
  }

  /* ----- Animations ----- */
  .fadeIn {
    opacity: 0;
    transition: opacity 1s;
    &.visible {
      opacity: 1;
    }
  }
  .fadeInFromBottom {
    opacity: 0;
    transform: translateY(100px);
    transition: opacity 1s, transform 1s;
    &.visible {
      opacity: 1;
      transform: translateY(0);
    }
    ${mediaMax('mobile')} {
      transform: translateY(50px);
    }
  }
`

export default GlobalStyle
